import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        sysTitle: '鲸鸿云平台',
        logoPath: require('../assets/logo.png'),
        userInfo: {
            userName: '',
            userCardID: '',
            loginType: 0,
            token: '',
            wechatUserCode: ''
        },
        tempPro: {
            Code: '',
            Name: '',
        },
        tempTeam: {
            Code: '',
            Name: '',
        },
        tempQuery:{},
        tempDayActive: 1,
        weChatAppId: 'wxbfaffdeb54f8836f', // 请求需要的传入的appid
        weChatUrl: 'https://wx.smze.cn', //回调的地址,当前项目地址
        webUrl: process.env.NODE_ENV === "development" ? 'http://localhost:8002' : "https://www.smze.cn", //回调的地址,当前项目地址
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        setTempPro(state,tempPro) {
            state.tempPro = tempPro
        },
        setTempTeam(state,tempTeam) {
            state.tempTeam = tempTeam
        },
        setTempDayActive(state,tempDayActive) {
            state.tempDayActive = tempDayActive
        },
        setTempQuery(state,tempQuery) {
            state.tempQuery = tempQuery
        }
    }
})